import { render } from "./NewPartner.vue?vue&type=template&id=2739def8"
import script from "./NewPartner.vue?vue&type=script&lang=js"
export * from "./NewPartner.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__